import { DOCUMENT } from '@angular/common';
import {
  Directive,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[cursorTooltip]'
})
export class CursorTooltipDirective implements OnChanges, OnDestroy {
  @Input() cursorTooltip = '';
  @Input() cursorTooltipDisabled = false;

  private readonly cursorOffset = 14;
  private readonly viewportMargin = 8;
  private tooltipElement?: HTMLElement;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
  }

  ngOnChanges(): void {
    if (this.cursorTooltipDisabled || !this.cursorTooltip) {
      this.hideTooltip();
    }
  }

  ngOnDestroy(): void {
    this.hideTooltip();
  }

  @HostListener('mouseenter', ['$event'])
  showTooltip(event: MouseEvent): void {
    if (this.cursorTooltipDisabled || !this.cursorTooltip || this.tooltipElement) {
      return;
    }

    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltipElement, 'cursor-tooltip');
    this.renderer.setAttribute(this.tooltipElement, 'role', 'tooltip');
    this.renderer.setProperty(this.tooltipElement, 'textContent', this.cursorTooltip);
    this.renderer.appendChild(this.document.body, this.tooltipElement);
    this.positionTooltip(event);
  }

  @HostListener('mousemove', ['$event'])
  moveTooltip(event: MouseEvent): void {
    this.positionTooltip(event);
  }

  @HostListener('mouseleave')
  hideTooltip(): void {
    if (!this.tooltipElement) {
      return;
    }

    this.renderer.removeChild(this.document.body, this.tooltipElement);
    this.tooltipElement = undefined;
  }

  private positionTooltip(event: MouseEvent): void {
    if (!this.tooltipElement) {
      return;
    }

    const view = this.document.defaultView;
    if (!view) {
      return;
    }

    const tooltipBounds = this.tooltipElement.getBoundingClientRect();
    let left = event.clientX + this.cursorOffset;
    let top = event.clientY + this.cursorOffset;

    if (left + tooltipBounds.width + this.viewportMargin > view.innerWidth) {
      left = event.clientX - tooltipBounds.width - this.cursorOffset;
    }

    if (top + tooltipBounds.height + this.viewportMargin > view.innerHeight) {
      top = event.clientY - tooltipBounds.height - this.cursorOffset;
    }

    this.renderer.setStyle(this.tooltipElement, 'left', `${Math.max(this.viewportMargin, left)}px`);
    this.renderer.setStyle(this.tooltipElement, 'top', `${Math.max(this.viewportMargin, top)}px`);
  }
}



// WEBPACK FOOTER //
// ./src/directives/cursor-tooltip.ts